export default {
	form: {
		required_error: 'Este campo es obligatorio',
		max_length_exceeded_error:
			'Este campo es demasiado largo (máximo {{length}} caracteres)'
	},
	legal: {
		copyright: 'Gerositus Sàrl - Todos los derechos reservados',
		i_consent: 'Consiento',
		agreement_title: 'Acuerdo',
		agreement_content:
			'Al usar Gerositus, aceptas nuestros <1>Términos y condiciones</1> y <2>Política de privacidad</2>.',
		agreement_terms_conditions: 'Términos y condiciones',
		agreement_privacy_policy: 'Política de privacidad',
	},
	navigation: {
		home: 'Home'
	},
	yes: 'Sí',
	no: 'No',
	not_defined: 'No definido',
	please_wait: 'Por favor espera',
	search: 'Buscar',
	upgrade_required: 'Upgrade required',
	create_project_title: 'What would you like to achieve?',
	click_to_change: 'Click to change',
	click_to_create_one: 'Click <button>to create one</button>',
	no_goal: 'No goal',

	auth: {
		token_expiring_soon: 'Tu sesión expirará en {{minutes}} minutos',
		token_expired:
			'Tu sesión ha expirado. Serás redirigido a la página de inicio de sesión.',
		token_check_error: 'Error al verificar el token',
		session_expiring:
			'Tu sesión está a punto de expirar. Por favor reconéctate. Tiempo restante: {{time}}'
	},
	bot: {
		placeholder: 'Ingresa tu pregunta aquí',
		security_notice: 'IA privada y aislada. Tus conversaciones permanecen confidenciales.'
	},
	tutorial: {
		button: 'Tutorial',
		exit_title: 'Exit tutorial',
		exit_confirm: 'Are you sure you want to exit the tutorial?'
	},
	subscription: {
		billing_monthly: 'Monthly',
		billing_yearly: 'Yearly',
		billing_yearly_save: '(save 20%)',
		choose_now: 'Choose now'
	},
	icons: {
		used: 'Used',
		unused: 'Unused'
	},
	theme: {
		selector: 'Selector de tema',
		current_theme: 'Tema actual',
		change_theme: 'Cambiar tema'
	},
	no_description: 'Sin descripción',
	situation_analysis: {
		title: 'Análisis de la situación',
		description: 'Analizar automáticamente una organización, empresa o situación',
		organization_label: 'Organización / empresa',
		organization_placeholder: 'Nombre de la organización a analizar',
		subject_label: 'Tema',
		subject_placeholder: 'Tema a analizar (precargado con el nombre del proyecto)',
		launch_analysis: 'Lanzar análisis',
		analysis_in_progress: 'Análisis en curso...',
		complete_analysis: 'Finalizar análisis',
		waiting_analysis: 'Esperando análisis...',
		waiting_summary: 'Esperando resumen...',
		waiting_stakes: 'Esperando retos...',
		waiting_risks: 'Esperando riesgos...',
		waiting_openings: 'Esperando oportunidades...',
		waiting_stakeholders: 'Esperando partes interesadas...',
		context_title: 'Contexto general',
		summary_title: 'Resumen',
		stakes_title: 'Retos',
		risks_title: 'Riesgos',
		openings_title: 'Oportunidades',
		stakeholders_title: 'Partes interesadas',
		status: 'Estado',
		likelihood: 'Probabilidad',
		impact: 'Impacto',
		stakeholder: {
			importance_label: 'Importancia relativa',
			propensity_label: 'Propensión',
			engagement_label: 'Compromiso',
			importance_values: {
				low: 'Baja',
				medium: 'Media',
				high: 'Alta'
			},
			propensity_values: {
				green: 'Favorable',
				neutral: 'Neutral',
				orange: 'Tensa',
				red: 'Adversa'
			},
			engagement_values: {
				inactive: 'Inactivo',
				neutral: 'Neutral',
				low: 'Bajo',
				medium: 'Medio',
				high: 'Fuerte'
			},
			polarity_values: {
				positive: 'apoyo',
				negative: 'oposición'
			}
		},
		risk_category_values: {
			operational: 'Operativo',
			strategic: 'Estratégico',
			existential: 'Existencial'
		}
	},
	ai_project_generation: {
		checkbox_label: 'Generar contenido con IA',
		checkbox_tooltip: "Utiliza el título, la misión, la descripción y los escenarios indicados abajo. La búsqueda pública con IA solo se lanza después de tu validación («Crear proyecto»).",
		title: 'Generación de proyecto asistida',
		go_to_project: 'Ir al proyecto',
		create_project: 'Crear proyecto',
		include_in_project_aria: 'Incluir este elemento en el proyecto',
		creation_modal_title: 'Creación de elementos',
		creation_progress_text: '{{current}} / {{total}} elementos creados',
		error_title: 'Error de generación',
		complete_title: 'Generación completada',
		complete_description: 'Tu proyecto se ha enriquecido correctamente. La IA ha identificado partes interesadas, retos, riesgos y oportunidades clave.',
		summary_title: 'Resumen del análisis',
		initializing_text: 'Preparando análisis profundo… Puede tardar entre 6 y 10 minutos.',
		include_in_project_tooltip: 'Si está marcado, este elemento se creará en el proyecto al hacer clic en «Crear proyecto».',
		language_code: 'es',
		patience_with_scenarios:
			'La generación de escenarios es compleja y puede tardar unos minutos. Gracias por su paciencia.',
		patience_no_scenarios:
			'El análisis en profundidad puede tardar unos minutos. Gracias por su paciencia.',
		phases: {
			initializing: 'Inicio',
			deep_research: 'Investigación',
			analyzing: 'Análisis IA',
			stakeholders: 'Partes interesadas',
			stakes: 'Retos',
			risks: 'Riesgos',
			openings: 'Oportunidades',
			summary: 'Resumen',
			fishbone: 'Plan de acción',
			entities: 'Entidades',
			scenarios: 'Escenarios',
			completed: 'Completado',
			error: 'Error'
			},
		section_title: "Detalles de la generación IA",
		disclosure_public_title: "A IA públicas",
		disclosure_public_sub: "Búsqueda web. Recibe únicamente la previsualización neutra a continuación — sin intención, sin objetivos.",
		disclosure_private_title: "IA privada y aislada",
		disclosure_private_sub: "Se ejecuta en un entorno aislado. Sin reentrenamiento, sin envío de datos al exterior. Procesa el título, la misión, la descripción y los escenarios.",
		zone_public: "Enviado a IA pública",
		zone_private: "Privado — no enviado a IA públicas",
		field_private_chip: "Privado y seguro",
		field_private_tooltip: "Procesado por una IA privada en un entorno aislado. Sin reentrenamiento, sin envío de datos al exterior.",
		preview_title: "Previsualización de la búsqueda",
		preview_refresh: "Regenerar previsualización",
		preview_hint: "Reformulación neutra de tu tema — sin rastro de intención. Esto es exactamente lo que se enviará a la búsqueda pública — solo tras tu validación.",
		preview_placeholder: "Indica al menos el título del proyecto para generar la previsualización.",
		launch_generation: "Iniciar generación",
		fishbone_source: 'Texto fuente',
		scenario_n: 'Escenario {{n}}',
		scenario_optimistic: 'Favorable',
		scenario_baseline: 'Probable',
		scenario_pessimistic: 'Desfavorable',
		scenario_pending: 'Pendiente',
		scenario_triggers: 'Eventos desencadenantes',
		scenario_action_window: 'Ventana de acción',
		scenario_detail: 'Análisis detallado',
		dismiss: 'Descartar sugerencias de IA y crear el proyecto',
		save_pdf: 'Guardar como PDF',
		save_hint: 'Puedes guardar este análisis antes de entrar al proyecto.',
		scenario_impacts: 'Impactos por entidad',
		data: {
			scenarios: 'Escenarios prospectivos',
			fishbone: 'Plan de acción estratégico'
		}
	},
	scenario_elaboration: {
		title: 'Elaboración de escenario con IA',
		hypothesis: 'Hipótesis',
		initializing: 'Inicializando análisis...',
		error_title: 'Error en la elaboración',
		complete_title: 'Elaboración completada',
		complete_description: 'El escenario se ha elaborado con éxito. Los cambios se han aplicado.',
		analysis_preview: 'Análisis preliminar',
		applied_changes: 'Cambios aplicados',
		stakeholders_modified: 'parte(s) interesada(s) modificada(s)',
		stakes_modified: 'reto(s) modificado(s)',
		risks_modified: 'riesgo(s)/oportunidad(es) modificada(s)',
		indicators_modified: 'indicador(es) modificado(s)',
		new_elements: 'nuevo(s)',
		steps: {
			started: 'Inicio',
			started_desc: 'Inicializando análisis...',
			fetching_project: 'Recuperando proyecto',
			fetching_project_desc: 'Cargando datos del proyecto...',
			deep_research: 'Análisis inicial',
			deep_research_desc: 'Análisis situacional profundo...',
			ai_analysis: 'Análisis IA',
			ai_analysis_desc: 'La IA está analizando el impacto de la hipótesis...',
			reformatting: 'Formateando',
			reformatting_desc: 'Estructurando resultados...',
			processing_stakeholders: 'Partes interesadas',
			processing_stakeholders_desc: 'Calculando impactos en las partes interesadas...',
			processing_stakes: 'Retos',
			processing_stakes_desc: 'Calculando impactos en los retos...',
			processing_risks: 'Riesgos',
			processing_risks_desc: 'Calculando impactos en los riesgos...',
			processing_indicators: 'Indicadores',
			processing_indicators_desc: 'Calculando impactos en los indicadores...',
			completed: 'Completado',
			completed_desc: 'Análisis completado con éxito',
			error: 'Error',
			error_desc: 'Se produjo un error'
		}
	}
};
